/**
 * The storefront identity's length limits. Their own module, free of
 * decorators, because both sides need them: the DTO enforces them and the
 * fields that write them refuse to exceed them. Importing the DTO into a
 * client component drags class-validator into the browser instead.
 *
 * A UI that lets someone type past the DTO turns a 400 into a mystery.
 *
 * The name is 60 (30 until 2026-10-20): a creator's Instagram name is often a line
 * like "Name | What I teach", and the mastheads fit a long name to their width.
 * The claim and the name editor share it, so a page never holds a name its owner
 * could not type.
 */
export const NAME_MAX = 60;

/** A name brought in from elsewhere (an Instagram profile), cut to fit at a word. */
export function clampName(name: string): string {
  const trimmed = name.trim();
  if (trimmed.length <= NAME_MAX) return trimmed;
  const cut = trimmed.slice(0, NAME_MAX);
  const space = cut.lastIndexOf(' ');
  return (space > NAME_MAX / 2 ? cut.slice(0, space) : cut).replace(/[\s|,.\-–—]+$/, '');
}
/** 90 since 2026-09-14: the tagline is the intro card's headline, about three
 *  lines on a phone. 65 stored bios were longer; the headline cuts them at a
 *  word, and the limit applies the next time their owner edits the line. */
export const BIO_MAX = 90;
